(function () {
  var JSON_FETCH_LIMIT = 50;

  function getLocaleRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    if (window.theme && window.theme.routes && window.theme.routes.home) {
      return window.theme.routes.home;
    }

    return '/';
  }

  function buildCollectionJsonUrl(handle) {
    var root = getLocaleRoot();
    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }

    return (
      root +
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      JSON_FETCH_LIMIT
    );
  }

  function parsePrice(value) {
    var num = Number(String(value || '').replace(',', '.').trim());
    return Number.isFinite(num) ? num : NaN;
  }

  function formatPrice(price) {
    if (!Number.isFinite(price)) {
      return '';
    }

    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: 'PLN'
    }).format(price);
  }

  function getDiscountPercent(compareAt, price) {
    if (!Number.isFinite(compareAt) || !Number.isFinite(price) || compareAt <= price || compareAt <= 0) {
      return 0;
    }

    return Math.round(((compareAt - price) / compareAt) * 100);
  }

  function shuffleArray(items) {
    var copy = items.slice();

    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }

    return copy;
  }

  function getFirstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) {
      return null;
    }

    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i] && product.variants[i].available) {
        return product.variants[i];
      }
    }

    return null;
  }

  function getProductImageSrc(product) {
    if (!product) {
      return '';
    }

    if (Array.isArray(product.images) && product.images.length && product.images[0].src) {
      return product.images[0].src;
    }

    if (product.featured_image) {
      return product.featured_image;
    }

    if (product.image && product.image.src) {
      return product.image.src;
    }

    return '';
  }

  function normalizeProduct(product) {
    var variant = getFirstAvailableVariant(product);
    var imageSrc = getProductImageSrc(product);

    if (!variant || !imageSrc || !product.handle) {
      return null;
    }

    var price = parsePrice(variant.price);
    var compareAt = parsePrice(variant.compare_at_price);
    var isPromo = Number.isFinite(compareAt) && Number.isFinite(price) && compareAt > price;

    return {
      handle: product.handle,
      title: product.title || '',
      imageSrc: imageSrc,
      imageAlt: (product.images && product.images[0] && product.images[0].alt) || product.title || '',
      price: price,
      compareAt: isPromo ? compareAt : NaN,
      isPromo: isPromo,
      discountPercent: isPromo ? getDiscountPercent(compareAt, price) : 0
    };
  }

  function selectProducts(products, maxCount) {
    var promos = [];
    var regular = [];
    var seen = {};

    products.forEach(function (product) {
      var normalized = normalizeProduct(product);

      if (!normalized || seen[normalized.handle]) {
        return;
      }

      seen[normalized.handle] = true;

      if (normalized.isPromo) {
        promos.push(normalized);
      } else {
        regular.push(normalized);
      }
    });

    promos = shuffleArray(promos);
    regular = shuffleArray(regular);

    var selected = promos.slice(0, maxCount);

    if (selected.length < maxCount) {
      selected = selected.concat(regular.slice(0, maxCount - selected.length));
    }

    return selected;
  }

  function createSvgArrow(direction) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('viewBox', '0 0 20 20');

    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.75');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    path.setAttribute('d', direction === 'prev' ? 'M12 4l-6 6 6 6' : 'M8 4l6 6-6 6');
    svg.appendChild(path);

    return svg;
  }

  function buildProductCard(item) {
    var rootPath = getLocaleRoot();
    if (rootPath.charAt(rootPath.length - 1) !== '/') {
      rootPath += '/';
    }

    var card = document.createElement('article');
    card.className = 'loanti-blog-carousel__card';

    var link = document.createElement('a');
    link.className = 'loanti-blog-carousel__link';
    link.href = rootPath + 'products/' + encodeURIComponent(item.handle);

    var imageWrap = document.createElement('div');
    imageWrap.className = 'loanti-blog-carousel__image-wrap';

    if (item.isPromo) {
      var badge = document.createElement('span');
      badge.className = 'loanti-blog-carousel__badge';
      badge.textContent = 'PROMOCJA';
      imageWrap.appendChild(badge);
    }

    var img = document.createElement('img');
    img.className = 'loanti-blog-carousel__image';
    img.src = item.imageSrc;
    img.alt = item.imageAlt;
    img.loading = 'lazy';
    imageWrap.appendChild(img);

    var content = document.createElement('div');
    content.className = 'loanti-blog-carousel__content';

    var title = document.createElement('h3');
    title.className = 'loanti-blog-carousel__product-title';
    title.textContent = item.title;

    var pricing = document.createElement('div');
    pricing.className = 'loanti-blog-carousel__price-row';

    var priceFormatted = formatPrice(item.price);
    if (priceFormatted) {
      var priceEl = document.createElement('span');
      priceEl.className = 'loanti-blog-carousel__price';
      priceEl.textContent = priceFormatted;
      pricing.appendChild(priceEl);
    }

    if (item.isPromo && item.discountPercent > 0) {
      var compareFormatted = formatPrice(item.compareAt);
      if (compareFormatted) {
        var compareEl = document.createElement('span');
        compareEl.className = 'loanti-blog-carousel__compare';
        compareEl.textContent = compareFormatted;
        pricing.appendChild(compareEl);
      }

      var saveEl = document.createElement('span');
      saveEl.className = 'loanti-blog-carousel__save';
      saveEl.textContent = '-' + item.discountPercent + '%';
      pricing.appendChild(saveEl);
    }

    content.appendChild(title);
    content.appendChild(pricing);
    link.appendChild(imageWrap);
    link.appendChild(content);
    card.appendChild(link);

    return card;
  }

  function buildCarousel(selectedProducts) {
    var section = document.createElement('section');
    section.className = 'loanti-blog-carousel';
    section.setAttribute('data-loanti-collection-carousel', '');

    var header = document.createElement('div');
    header.className = 'loanti-blog-carousel__header';

    var heading = document.createElement('div');
    heading.className = 'loanti-blog-carousel__title';
    heading.textContent = 'Modele warte uwagi';

    var controls = document.createElement('div');
    controls.className = 'loanti-blog-carousel__controls';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'loanti-blog-carousel__button loanti-blog-carousel__button--prev';
    prevBtn.setAttribute('data-loanti-prev', '');
    prevBtn.setAttribute('aria-label', 'Poprzednie produkty');
    prevBtn.appendChild(createSvgArrow('prev'));

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'loanti-blog-carousel__button loanti-blog-carousel__button--next';
    nextBtn.setAttribute('data-loanti-next', '');
    nextBtn.setAttribute('aria-label', 'Następne produkty');
    nextBtn.appendChild(createSvgArrow('next'));

    controls.appendChild(prevBtn);
    controls.appendChild(nextBtn);
    header.appendChild(heading);
    header.appendChild(controls);

    var viewport = document.createElement('div');
    viewport.className = 'loanti-blog-carousel__viewport';

    var track = document.createElement('div');
    track.className = 'loanti-blog-carousel__track';

    selectedProducts.forEach(function (item) {
      track.appendChild(buildProductCard(item));
    });

    viewport.appendChild(track);
    section.appendChild(header);
    section.appendChild(viewport);

    return section;
  }

  function hidePlaceholder(placeholder) {
    if (!placeholder) {
      return;
    }

    placeholder.style.display = 'none';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.removeAttribute('aria-busy');
    delete placeholder.dataset.loantiLoading;
  }

  function initCarouselArrows(carousel) {
    if (!carousel || carousel.dataset.loantiInitialized === '1') {
      return;
    }

    var viewport = carousel.querySelector('.loanti-blog-carousel__viewport');
    var prev = carousel.querySelector('[data-loanti-prev]');
    var next = carousel.querySelector('[data-loanti-next]');

    if (!viewport) {
      return;
    }

    function scrollStep() {
      return Math.max(viewport.clientWidth * 0.9, 280);
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        viewport.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        viewport.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
    }

    carousel.dataset.loantiInitialized = '1';
  }

  function getLoantiCollectionHandle(placeholder) {
    var fromData = placeholder.getAttribute('data-collection-handle');
    if (fromData) {
      return fromData.trim();
    }

    var source = placeholder.querySelector('.loanti-dynamic-carousel-source');
    if (source && source.textContent.trim()) {
      return source.textContent.trim();
    }

    var classNames = Array.from(placeholder.classList);
    var className;
    for (var i = 0; i < classNames.length; i++) {
      if (classNames[i].indexOf('loanti-dynamic-collection--') === 0) {
        className = classNames[i];
        break;
      }
    }

    if (className) {
      return className.replace('loanti-dynamic-collection--', '');
    }

    var id = placeholder.id || '';
    if (id.indexOf('loanti-dynamic-collection-') === 0) {
      return id.replace('loanti-dynamic-collection-', '');
    }

    return '';
  }

  function findLoantiCarouselMarkers(root) {
    var results = [];
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          var parent = node.parentElement;

          if (!parent) {
            return NodeFilter.FILTER_REJECT;
          }

          if (parent.closest('script, style, textarea, input, select, option, noscript')) {
            return NodeFilter.FILTER_REJECT;
          }

          var value = String(node.nodeValue || '').trim();

          return /^LOANTI_CAROUSEL_HANDLE:([a-z0-9-]+)$/.test(value)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    var node;

    while ((node = walker.nextNode())) {
      var value = String(node.nodeValue || '').trim();
      var match = value.match(/^LOANTI_CAROUSEL_HANDLE:([a-z0-9-]+)$/);

      if (match) {
        results.push({
          node: node,
          handle: match[1]
        });
      }
    }

    return results;
  }

  function convertLoantiCarouselMarkers(root) {
    var markers = findLoantiCarouselMarkers(root);

    console.info('[Loanti carousel] text markers found:', markers.length);

    markers.forEach(function (item) {
      var node = item.node;
      var handle = item.handle;
      var parent = node.parentElement;

      if (!parent) {
        return;
      }

      var placeholder = document.createElement('div');
      placeholder.className = 'loanti-dynamic-collection-carousel';
      placeholder.setAttribute('data-loanti-dynamic-carousel', '');
      placeholder.setAttribute('data-collection-handle', handle);
      placeholder.setAttribute('data-product-limit', '8');
      placeholder.setAttribute('aria-live', 'polite');

      var parentText = String(parent.textContent || '').trim();

      if (parentText === 'LOANTI_CAROUSEL_HANDLE:' + handle) {
        parent.replaceWith(placeholder);
      } else {
        node.parentNode.replaceChild(placeholder, node);
      }

      console.info('[Loanti carousel] marker converted:', handle);
    });
  }

  function loadDynamicCarousel(placeholder) {
    if (!placeholder || placeholder.dataset.loantiLoading === '1' || placeholder.dataset.loantiLoaded === '1') {
      return;
    }

    var handle = getLoantiCollectionHandle(placeholder);
    if (!handle) {
      hidePlaceholder(placeholder);
      return;
    }

    var limit = parseInt(placeholder.getAttribute('data-product-limit'), 10);
    if (!limit || limit < 1) {
      limit = 8;
    }
    if (limit > 20) {
      limit = 20;
    }

    placeholder.dataset.loantiLoading = '1';
    placeholder.setAttribute('aria-busy', 'true');

    var jsonUrl = buildCollectionJsonUrl(handle);
    console.info('[Loanti carousel] collection JSON request', jsonUrl);

    fetch(jsonUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          console.error('[Loanti carousel] collection JSON failed', response.status);
          throw new Error('Collection JSON request failed');
        }

        return response.json();
      })
      .then(function (data) {
        var products = data && data.products;

        if (!Array.isArray(products)) {
          console.info('[Loanti carousel] products received', 0);
          hidePlaceholder(placeholder);
          return;
        }

        console.info('[Loanti carousel] products received', products.length);

        var selected = selectProducts(products, limit);
        console.info('[Loanti carousel] products rendered', selected.length);

        if (!selected.length) {
          hidePlaceholder(placeholder);
          return;
        }

        var carousel = buildCarousel(selected);
        placeholder.replaceWith(carousel);
        initCarouselArrows(carousel);
      })
      .catch(function () {
        hidePlaceholder(placeholder);
      });
  }

  function initLoantiDynamicCarousels(root) {
    root = root || document;

    root.querySelectorAll('[data-loanti-dynamic-carousel], .loanti-dynamic-collection-carousel').forEach(loadDynamicCarousel);
    root.querySelectorAll('[data-loanti-collection-carousel]').forEach(initCarouselArrows);
  }

  function bootLoantiBlogCarousels(root) {
    root = root || document;

    var articleRoot =
      (root.querySelector && root.querySelector('[itemprop="articleBody"]')) ||
      (root.querySelector && root.querySelector('.article__body')) ||
      (root.querySelector && root.querySelector('.article__content')) ||
      (root.querySelector && root.querySelector('.rte')) ||
      root.body ||
      root;

    convertLoantiCarouselMarkers(articleRoot);
    initLoantiDynamicCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootLoantiBlogCarousels(document);
    });
  } else {
    bootLoantiBlogCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootLoantiBlogCarousels(event.target);
  });
})();
